<template>
  <div>
    <div :class="['uploader', `uploader--${theme}`]">
      <div class="uploader__header">
        <label>{{ label }}</label>
      </div>
      <div
        class="uploader__dragdrop"
        @dragover.prevent=""
        @dragenter.prevent=""
        @drop.prevent="addToFiles"
      >
        <div>
          <label
            class="uploader__button"
            for="uploader-buttom"
          >
            <img
              src="/images/upload-blue.png"
              width="50px"
            >
            <div>
              <slot />
              <p class="description">{{ limitText }}</p>
            </div>
          </label>
          <input
            id="uploader-buttom"
            ref="fileInput"
            class="uploader__input"
            type="file"
            multiple
            :accept="getAccept"
            @input.prevent="addToFiles"
          >
        </div>
      </div>
      <!-- Errors -->
      <div
        v-if="error"
        class="nt-form-error"
      >
        {{ error }}
      </div>
      <!-- List and others -->
      <div
        v-if="uploadedLength"
        class="uploader__loader"
      >
        <div
          v-if="!limitSizeExceeded"
          class="total"
        >
          {{ uploadedText }} <span>{{ sumSizes }}</span>
        </div>
        <div
          v-else
          class="nt-form-error total total--error"
        >
          {{ limitExcededText }}
        </div>
        <div
          class="loader"
          :class="[limitSizeExceeded ? 'loader--error' : null]"
        >
          <span :style="{ width: loadingSize }" />
        </div>
      </div>
      <ul
        v-if="list.length"
        class="uploader__list"
      >
        <li
          v-for="(item, index) in list"
          :key="index"
        >
          <file
            :data="item"
            :position="index"
            :exceeded="item.exceeded"
            @removeFile="removeFile"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import emitter from 'tiny-emitter/instance'
import file from './uploader-file.vue'

/* eslint-disable */
export default {
  name: 'uploader',
  props: {
    theme: {
      type: String,
      default: 'default'
    },
    id: {
      type: String,
      default: 'uploader'
    },
    label: {
      type: String,
      default: 'Label Text'
    },
    limitText: {
      type: String,
      default: 'Limited up to 5 files and 8mb in total (.png .jpg .pdf .tiff)'
    },
    limitExcededText: {
      type: String,
      default: 'Limit of 8mb exceded. Please remove some files.'
    },
    uploadedText: {
      type: String,
      default: 'Total uploaded:'
    },
    maxFiles: {
      type: Number,
      default: 5
    },
    maxLength: {
      type: Number,
      default: 8
    },
    validators: {
      type: Array,
      default: []
    },
    acceptTypes: {
      type: Array,
      default: () => ['image/png', 'image/jpg', 'image/jpeg', 'image/tiff', 'application/pdf']
    }
  },
  data() {
    return {
      files: [],
      error: null,
      totalLength: (1024 * 1024) * this.maxLength,
      uploadedLength: 0,
      loader: 0
    }
  },
  watch: {
    files(values) {
      const { fileInput } = this.$refs
      fileInput.value = ''
    },
    errors: {
      handler(values) {
        const error = values.find((value) => value[id]) || {}
        this.error = error[id]
      },
      deep: true
    }
  },
  computed: {
    ...mapState('formStore', ['errors']),
    getAccept() {
      return this.acceptTypes.join(',')
    },
    loadingSize() {
      return `${this.loader}%`
    },
    list() {
      return this.files;
    },
    sumSizes(){
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        if (this.uploadedLength === 0) return '0 Byte';

        const i = parseInt(Math.floor(Math.log(Math.abs(this.uploadedLength)) / Math.log(1024)), 10);

        if (i === 0) {
          return `${this.uploadedLength} ${sizes[i]})`;
        };
        
        return `${(this.uploadedLength / (1024 ** i)).toFixed(2)} ${sizes[i]}`;
    },
    limitSizeExceeded() {
      return this.uploadedLength > this.totalLength
    }
  },
  created() {
    // Add to form initial values
    this.changeFormData({
      [this.id]: this.list
    })
    // Add validators to form
    this.changeValidators({
      [this.id]: this.validators
    })
  },
  methods: {
    ...mapActions('formStore', ['changeFormData', 'changeValidators']),
    checkTotalSize() {
      this.uploadedLength = 0;

      _.each(this.files, (item) => {
        this.uploadedLength += item.size;
        item.exceeded = this.uploadedLength > this.totalLength;
      })

      this.loader = this.uploadedLength * 100 / this.totalLength;
    },
    changeForm() {
      this.checkTotalSize();

      emitter.emit('changeForm', {
        [this.id]: _.filter(this.files, ['exceeded', false])
      })
      
    },
    addToFiles() {
      let { files } = event.dataTransfer || event.target;

      for (let i = 0; i < files.length; i++) {
        if (this.files.length < this.maxFiles) {
          var file = files[i];
          
         if(_.includes(this.acceptTypes, file.type)){
           this.files.push(file);
         };
        }
      }

      this.changeForm()
    },
    removeFile(index) {
      this.files.splice(index, 1)

      this.changeForm()
    }
  },
  components: {
    file
  }
}
</script>

<style lang="scss" scoped>
  .uploader {
    &__header {
      display: flex;
      justify-content: space-between;
      // margin-bottom: 10px;
      font-size: 14px;

      & > div {
        font-size: 12px;
        font-style: italic;
      }
    }

    &__dragdrop {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #CCC;
      padding: 10%;
    }

    &__button {
      display: flex;
      align-items: center;
      cursor: pointer;

      & img {
        margin: 0 10px;
      }

      & span {
        color: #3e8ccc;
        font-weight: 600;
      }

      & .description {
        font-style: italic; 
        text-transform: none; 
        font-weight: 400;
        font-size: 13px;
      }
    }

    &__input {
      opacity: 0;
      position: absolute;
      z-index: -1;
    }

    &__loader {
      margin: 25px 0;

      & > .total {
        text-align: center;
        margin-bottom: 15px;
        color: #908782;
        font-size: 14px;

        &--error {
          color: #E97462;
        }
      }

      & > .loader {
          border: 1px solid #CCC;
          height: 10px;
          border-radius: 20px;
          overflow: hidden;
          position: relative;

        & > span {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          background-color: #3e8ccc;
          border-radius: 14px;
        }

        &--error {
          span {
            background-color: #E97462;
          }
        }
      }
    }

    &__list {
      padding: 0;
      margin: 0;
      margin-top: 10px;

      & > li {
        list-style: none;

        &:not(:last-of-type) {
          margin-bottom: 5px;
        }
      }
    }
  }
</style>